<script lang="ts">
  export let data
  import { onMount } from "svelte"
  import { shows } from "$lib/i18n"
  import "../app.css";
</script>

<slot/>